module.exports = __webpack_public_path__ + "static/media/shri-ramanlal-ji-maharaj.80b2727d.jpg";